import React from "react";
import AdminLayout from "../../layouts/admin-layout";

function Admin() {
    return <AdminLayout>
    </AdminLayout>;
}

export default Admin;